import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { clinicService } from '../services/clinic.service'
import { ClinicCreate } from '../types'

export const useClinics = () => {
  const queryClient = useQueryClient()

  const useMyClinics = () => {
    return useQuery({
      queryKey: ['my-clinics'],
      queryFn: clinicService.getMyClinics,
    })
  }

  const useCreateClinic = () => {
    return useMutation({
      mutationFn: (data: ClinicCreate) => clinicService.createClinic(data),
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['my-clinics'] })
      },
    })
  }

  const useSwitchClinic = () => {
    return useMutation({
      mutationFn: (clinicId: string) => clinicService.switchClinic(clinicId),
    })
  }

  return {
    useMyClinics,
    useCreateClinic,
    useSwitchClinic,
  }
}
